import * as React from 'react';
import * as navigate from 'app/area/shared/navigation';
import { scrollToTop } from 'app/infrastructure/platform/routing';
import { keyCodeTypes } from 'ui/common/key-code-types';

export function withSectionKeyboardPaging() {

  return (
    WrappedComponent: React.ComponentClass<any> | React.FC<React.PropsWithChildren<{}>>
  ): React.ComponentClass<{}> => {

    /**
     * Using enhancers/HOC to register window event listeners seems like
     * a fragile approach. This should probably be changed when better
     * ways surface.
     * The reason is the nature of addEventListener and the chance of losing the
     * correct memory reference to the event handler when unregistering. That
     * is why keydown is added and removed on every update, since there was
     * duplicate event handlers firing.
     */
    return class extends React.PureComponent<any> {

      public constructor(props: any) {
        super(props);
      }

      public componentDidMount() {
        addEventListener('keydown', this.handleKeyboardShortcut);
      }

      public componentWillUnmount() {
        removeEventListener('keydown', this.handleKeyboardShortcut);
      }

      private page = (sectionId: number) => {
        navigate.toSection(sectionId);
        this.props.onSelectDocumentItem(null);
        scrollToTop();
      };

      private handleKeyboardShortcut = (event: KeyboardEvent) => {
        const { previousSection, nextSection, expandAll } = this.props;
        if (! (event.ctrlKey && event.shiftKey) || expandAll) {
          return;
        }

        if (event.code === keyCodeTypes.ArrowLeft && previousSection) {
          event.preventDefault();
          this.page(previousSection.id);
        }
        if (event.code === keyCodeTypes.ArrowRight && nextSection) {
          event.preventDefault();
          this.page(nextSection.id);
        }
      };

      public render(){
        return <WrappedComponent {...this.props} />;
      }
    };
  };
}
